import script from "./NotificationBox.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationBox.vue?vue&type=script&setup=true&lang=js"

import "./NotificationBox.vue?vue&type=style&index=0&id=0a1c3143&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a1c3143"]])

export default __exports__